define('views/register/address_confirmation',[
	'backbone',
	'views/_base/baseview',
	'text!views/register/address_confirmation.html',
	'text!views/register/address_confirmation_rxsavings.html',
	'text!views/register/address_confirmation_proteus.html',
	'text!views/register/address_confirmation_alahealth.html',
	'text!views/register/address_confirmation_csnp.html',
	'views/shared/form/form_component',
	'models/user/register/address',
	'models/user/register/status',
	'models/shared/user/user',
	'views/root/disclaimer'
], function(Backbone, BaseView, Template, RxSavingsTemplate, ProteusTemplate, AlahealthTemplate, CSNPTemplate, FormComponent, AddressModel, SimpleRegStatusModel, UserModel, DisclaimerComponent){
	'use strict';

	return BaseView.extend({
		className: 'register-container',
		tagName  : 'div',
		isRender : false,
		events   : {},

		initialize: function(options){
			options = options || {};

			this.site_version = pf.getContent('version.id');

			if (this.site_version === enums.siteVersion.bcbsal || this.site_version === enums.siteVersion.alahealth || this.site_version === enums.siteVersion.almyblue) {
				var set_id = enums.registrationSetId.simple_reg_with_address_verification;
			} else {
				var set_id = enums.registrationSetId.regular_subscriber_id_email;
			}

			var form_id = enums.registrationId.regular,
				form_options = {
					set_id: set_id,
					id    : enums.registrationId.financial,
					depth : 2
				};

			this.registration = pf.getFeatureById(form_id, form_options);


			this.update_address_status_interval = null;
			this.status_invterval_count = 0;

			this.response_token = options.response_token;

			this.user_model = null;

			this.user_model_json = {};
			
			this.elementName = options.elementName;

			if (this.site_version !== enums.siteVersion.alahealth && this.site_version !== enums.siteVersion.csnp && this.site_version !== enums.siteVersion.centene && this.site_version !== enums.siteVersion.bcbskc) {
				startPanoScrollAnimator('.register-content-container', .25);
			}

			// console.log('address confirmation',this, form_id, form_options);

			BaseView.prototype.initialize(this);
		},

		render: function(){
			var that = this,
				template = null;

			if(this.site_version == enums.siteVersion.rxsavings){

				template = _.template(RxSavingsTemplate);

			} else if (this.site_version == enums.siteVersion.proteus) {

				template = _.template(ProteusTemplate);
			
			} else if (this.site_version == enums.siteVersion.alahealth) {

				template = _.template(AlahealthTemplate);	

			} else if (this.site_version == enums.siteVersion.csnp || this.site_version == enums.siteVersion.centene || this.site_version == enums.siteVersion.bcbskc) {

				template = _.template(CSNPTemplate);	

			} else {

				template = _.template(Template);

			}

			this.$el.addClass(pf.getContent('version.name')).html(template());

			this.addRegistrationForm();

			// Add Disclaimers
			this.addDisclaimers();

			return this;
		},

		loadData: function(){
			var that = this;

			if(_.isObject(pf.header)){

				pf.header.header_state = enums.user_state.logged_in;

				// pf.globalEvents.trigger('header_state');

				pf.header.render();

			}

			store.getStoreItem(enums.modelsEnum.UserInfo, { ID: pf.session.get('UserGUID') }, false, true, true, function(Data){
				that.user_model = new UserModel(Data);

				that.user_model_json = that.user_model.toJSON();

				that.render();
			});

		},

		addDisclaimers: function(){

			var disclaimers = new DisclaimerComponent({ elementName: '.js-confirm-address-disclosures' });

		},

		addRegistrationForm: function(){
			var that = this,
				form_fields = pf.getContent('register.content.form.confirm.address.fields'),
				button_data = pf.getContent('register.content.form.confirm.address.button_component'),
				route = pf.getContent('register.content.form.confirm.address.route');

			if(_.isObject(this.registration)){

				// console.log('addRegistrationForm',button_data,route);

				this.address_registration_form = new FormComponent({
					elementName: '.js-confirm-address-form',
					button_data: button_data,
					route      : route,
					feature    : this.registration,
					content_fields: form_fields,
					form_type  : enums.formType.features,
					form_page  : 1,
					validated  : function(fields, confirm){

						console.log('addRegistrationForm validated:',fields,confirm);

						that.confirmAddress();

					},
					success    : function(end){
						// console.log('addRegistrationForm success:',end);
						// Route to next step or home
						that.addressUpdateSuccess();
					},
					error      : function(errors){
						// console.log('addRegistrationForm error:',errors);
						that.addressUpdateError();
					}
				});

				// TEMPORARY: remove PO BOX validation for bcbssc and bcbsal only
				if(this.site_version == enums.siteVersion.bcbssc || this.site_version == enums.siteVersion.bcbsal || this.site_version == enums.siteVersion.csnp || this.site_version == enums.siteVersion.almyblue || this.site_version == enums.siteVersion.centene || this.site_version == enums.siteVersion.bcbskc){

					this.address_registration_form.removeFieldValidation(enums.formComponentTypes.street_address, enums.form_validation.po_box);

				}

				// Update the address form with potentially known values
				this.address_registration_form.updateFieldValue(enums.formComponentTypes.street_address, this.user_model_json.AddressLine1);
				
				if(this.user_model_json.City){
					this.address_registration_form.updateFieldValue(enums.formComponentTypes.city, this.user_model_json.City);
				}

				this.address_registration_form.updateFieldValue(enums.formComponentTypes.state, this.user_model_json.StateID);
				this.address_registration_form.updateFieldValue(enums.formComponentTypes.zipcode, this.user_model_json.ZipCode);

				if(this.user_model_json.PhoneNumber){
					this.address_registration_form.updateFieldValue(enums.formComponentTypes.phone, this.user_model_json.PhoneNumber);
				}

			}

		},

		confirmAddress: function(){

			var that = this,
				data = this.address_registration_form.getFieldValues();

			this.address_model = new AddressModel(data);

			// console.log('confirmAddress', data, this.address_model);

			Backbone.sync('update',this.address_model, {
				success: function(a,b,c){
					// console.log('Backbone sync success:',a,b,c);
					that.startStatusInterval();
					
				},
				error: function(a,b,c){
					// console.log('Backbone sync error:',a,b,c);

					// if(_.isFunction(that.address_registration_form.acknowledgedValidation)){
					//     that.address_registration_form.acknowledgedValidation(false);
					// }

					// Temporary
					that.startStatusInterval();
				}
			});

		},

		startStatusInterval: function(){
			var that = this;

			this.update_address_status_interval = setInterval(function (){

				if(that.status_invterval_count < 24){

					// Call the polling endpoint
					that.checkAddressUpdateStatus();

				} else {

					clearInterval(that.update_address_status_interval);

					if(_.isFunction(that.address_registration_form.acknowledgedValidation)){
						that.address_registration_form.acknowledgedValidation(false);
					}

				}
				
			}, 5000);

		},

		checkAddressUpdateStatus: function(){
			var that = this,
				user_guid = pf.session.get('UserGUID') || '';

			this.update_address_status_check = new SimpleRegStatusModel({ UG: user_guid });

			this.update_address_status_check.fetch({
				success: function(modelStatus, respStatus, options){

					that.status_invterval_count = that.status_invterval_count+1;

					// console.log('checkAddressUpdateStatus', options.xhr.status, modelStatus, respStatus, options);

					// 202: Processing, 200: Good
					if(options.xhr.status == 200){

						clearInterval(that.update_address_status_interval);

						if(_.isFunction(that.address_registration_form.acknowledgedValidation)){
							that.address_registration_form.acknowledgedValidation(true);
						}

					}

				},
				error: function(modelStatus, respStatus, options){

					clearInterval(that.update_address_status_interval);

					if(options.xhr.status == 412){

						saveCipTriggerRoute('wellness');

						pf.navigate('register/financial/cip',{ trigger: true });

					} else {

						if(_.isFunction(that.address_registration_form.acknowledgedValidation)){
							that.address_registration_form.acknowledgedValidation(false);
						}

					}

				}
			});

		},

		addressUpdateSuccess: function(){
			var that = this,
				route = pf.getContent('register.content.form.confirm.address.route');

			if(this.response_token){
				pf.session.saveToken(this.response_token);
			}

			store.getStoreItem(enums.modelsEnum.UserInfo, { ID: pf.session.get('UserGUID') }, false, true, true, function(Data){
				that.user_model = new UserModel(Data);

				that.user_model_json = that.user_model.toJSON();

				pf.session.set('UserStatusId', that.user_model_json.UserStatusId);

				pf.header.header_state = enums.user_state.logged_in_confirmed;

				pf.header.render();

				if(route){
					pf.navigate(route, { trigger: true });
				}

			});

		},

		addressUpdateError: function(){},

		close: function(){}
	});
});

